import React from 'react';
import LocationsSelector from './LocationsSelector.jsx';
import DispositionsSelector from './DispositionsSelector.jsx';
import ProductsDetailsSelector from './ProductsDetailsSelector.jsx';
import ConfigureFormCalendar from './ConfigureFormCalendar.jsx';
import { withTranslation } from 'react-i18next';

class ConfigureProductFormComponent extends React.Component {
    constructor(props) {
        super(props);
        
        this.devisInputHourStart = $('#products_locations_hour_start_'+this.props.index);
        this.devisInputHourEnd = $('#products_locations_hour_end_'+this.props.index);
        this.devisInputMRType = $('#products_locations_meeting_rooms_type_slug_'+this.props.index);
        this.devisInputLocationsId = $('#products_locations_locations_id_'+this.props.index);
        this.devisInputPDOId = $('#products_locations_products_details_origin_id_'+this.props.index);
        this.devisInputPAX = $('#products_locations_pax_'+this.props.index);
        this.devisInputProductLabel = $('#products_product_label_'+this.props.index);
        this.devisInputProductDescription = $('[name^="products[' + this.props.index + '][product_description]"]');
        this.devisInputPrice = $('#price_'+this.props.index);

        this.divLibLocation = $('.lib-location[data-index="'+this.props.index+'"]');
        this.divLibRmType = $('.lib-rm-type[data-index="'+this.props.index+'"]');
        this.divLibRmPax = $('.lib-rm-pax[data-index="'+this.props.index+'"]');
        this.divHourStart = $('.lib-hour-start[data-index="'+this.props.index+'"]');
        this.divHourEnd = $('.lib-hour-end[data-index="'+this.props.index+'"]');
        
        this.state = {
            isLoaded: false,
            locations: [],
            disposition: null,
            product_detail: null,

            hour_start: null,
            hour_start_displayed: '',

            hour_end: null,
            hour_end_displayed: '',

            pax: '',
            all_dispositions: [],
            all_pax: {},
            product_title: this.devisInputProductLabel.val(),

            default_meeting_rooms_type_slug: null,
            default_products_details_origin_id: null,
            default_locations: [],

            locations_component_loaded: false,
            dispositions_component_loaded: false,
            products_component_loaded: false,

            force_hours_change: true,

            locations_ids: '',
            locations_labels: '',

            global: 0
        };
    }

    componentDidMount() {
        this.loadFormProductData();
    }

    loadFormProductData() {
        let locations_ids = this.devisInputLocationsId.val();
        let disposition = this.devisInputMRType.val();
        let hour_start = this.devisInputHourStart.val();
        let hour_end = this.devisInputHourEnd.val();
        let product_detail_id = this.devisInputPDOId.val();
        let pax = this.devisInputPAX.val();
        const global = $('.products_global[data-index="'+this.props.index+'"]').val();
        
        let new_state = {
            pax: pax,
            hour_start: hour_start,
            hour_start_displayed: hour_start,
            hour_end: hour_end,
            hour_end_displayed: hour_end,
            default_locations: locations_ids.split(','),
            default_meeting_rooms_type_slug: disposition,
            default_products_details_origin_id: product_detail_id,
            force_hours_change: !(product_detail_id > 0),
            global: global
        };
        this.setState(new_state);
    }

    handleLoadDispositions = (dispositions) => {
        this.setState({
            all_dispositions: dispositions,
            dispositions_component_loaded: true
        }, () => {
            this.setState({
                isLoaded: this.checkIsLoaded()
            });
        });
    }

    handleLoadLocations = () => {
        this.setState({
            locations_component_loaded: true
        }, () => {
            this.setState({
                isLoaded: this.checkIsLoaded()
            }, () => { this.recalcPax() } 
            );
        });
    }

    handleLoadProducts = () => {
        this.setState({
            products_component_loaded: true
        }, () => {
            this.setState({
                isLoaded: this.checkIsLoaded()
            });
        });
    }

    handleChangeLocations = (locations) => {

        let old_locations = this.state.locations;
        let locations_ids = [];
        let locations_labels = [];
        locations.map((location) => {
            locations_ids.push(location.value);
            locations_labels.push(location.label);
        })

        this.setState({
            locations: locations,
            locations_ids: locations_ids.join(','),
            locations_labels: locations_labels.join(', '),
            refreshProductsDetailsSelect: true,
            isLoaded: this.checkIsLoaded()
        }, () => {
            this.recalcPax();
            if(JSON.stringify(old_locations) != JSON.stringify(locations)) {
                this.handleSubmit();
            }
            
        });

    }

    handleChangeDisposition = (disposition) => {
        let old_disposition = this.state.disposition;
        this.setState({
            disposition: disposition,
            refreshPax: false,
            isLoaded: this.checkIsLoaded()
        }, () => {
            this.recalcPax();
            if(JSON.stringify(old_disposition) != JSON.stringify(disposition)) {
                this.handleSubmit();
            }
        });
    }

    handleChangeProductDetail = (product_detail) => {
        let old_product_detail = this.state.product_detail;
        let newState = {
            product_detail: product_detail,
            refreshProductsDetailsSelect: false,
            force_hours_change: true,
            isLoaded: this.checkIsLoaded()
        };
        
        if(this.state.force_hours_change) {
            if(product_detail.hour_start) {
                newState.hour_start = product_detail.hour_start;
                newState.hour_start_displayed = product_detail.hour_start;
            }
            if(product_detail.hour_end) {
                newState.hour_end = product_detail.hour_end;
                newState.hour_end_displayed = product_detail.hour_end;
            }
        }
        this.setState(newState, () => {
            if(JSON.stringify(old_product_detail) != JSON.stringify(product_detail)) {
                this.handleSubmit();
            }
        });
    }

    handleHourStartChange = (event) => {   
        let old_hour_start = this.state.hour_start;
        let new_state = {
            hour_start_displayed: event.target.value
        }
        if(event.target.value === '') {
            new_state.hour_start = event.target.value;
            new_state.isLoaded =  this.checkIsLoaded()
            this.setState(new_state, () => {
                if(old_hour_start != event.target.value) {
                    this.handleSubmit();
                }
            });
        } else {
            this.setState(new_state);
        }
        
    }

    handleHourStartBlur = (event) => {   
        let old_hour_start = this.state.hour_start;
        this.setState({
            hour_start: event.target.value,
            isLoaded: this.checkIsLoaded()
        }, () => {
            if(old_hour_start != event.target.value) {
                this.handleSubmit();
            }
        });
    }

    handleHourEndChange = (event) => {   
        let old_hour_end = this.state.hour_end;
        let new_state = {
            hour_end_displayed: event.target.value
        }
        if(event.target.value === '') {
            new_state.hour_end = event.target.value;
            new_state.isLoaded =  this.checkIsLoaded();
            this.setState(new_state, () => {
                if(old_hour_end != event.target.value) {
                    this.handleSubmit();
                }
            });
        } else {
            this.setState(new_state);
        }
    }

    handleHourEndBlur = (event) => {  
        let old_hour_end = this.state.hour_end; 
        this.setState({
            hour_end: event.target.value,
            isLoaded: this.checkIsLoaded()
        }, () => {
            if(old_hour_end != event.target.value) {
                this.handleSubmit();
            }
        });
    }

    handlePaxChange = (event) => {   
        let old_pax = this.state.pax; 
        this.setState({
            pax: event.target.value,
            isLoaded: this.checkIsLoaded()
        }, () => {
            if(old_pax != event.target.value) {
                this.handleSubmit();
            }
        });
    }

    recalcPax() {
        let all_pax = {
        };

        this.state.all_dispositions.map((dispo) => {
            all_pax[dispo.value] = 0;
        });
        
        this.state.locations.map((item) => {
            this.state.all_dispositions.map((dispo) => {
                let dispo_pax = parseInt(item[dispo.value] ?? 0);
                //all_pax[dispo.value] = dispo_pax>all_pax[dispo.value] ? dispo_pax : all_pax[dispo.value];
                all_pax[dispo.value] += dispo_pax;
            });
        });
        this.setState({
            all_pax: all_pax,
            refreshPax: true
        });
    }


    handleSubmit = () => {
        this.devisInputLocationsId.val(this.state.locations_ids);
        this.devisInputMRType.val(this.state.disposition ? this.state.disposition.value : '');
        this.devisInputHourStart.val(this.state.hour_start ?? '');
        this.devisInputHourEnd.val(this.state.hour_end ?? '');
        this.devisInputPDOId.val(this.state.product_detail ? this.state.product_detail.id : '');
        this.devisInputPAX.val(this.state.pax ?? '');

        if(this.state.product_detail) {
            let new_price = parseInt(this.state.product_detail.price_ttc);
            // Si produit identique déjà existant dans le devis, on ne remplace pas le prix présent dans le devis
            if(new_price > 0 && (!this.state.default_products_details_origin_id || this.state.default_products_details_origin_id !== this.state.product_detail.id)) {
                this.devisInputPrice.val(new_price);
                this.devisInputPrice.trigger('change');
            }
        }
        
        let tiret = '';
        if(this.state.force_hours_change && this.state.product_detail) {
            // Si produit identique déjà existant dans le devis, on ne remplace pas le titre et la description présente dans le devis
            if(this.state.product_detail.product_label) {
                if (!this.state.default_products_details_origin_id || this.state.default_products_details_origin_id !== this.state.product_detail.id) {
                    this.devisInputProductLabel.val(this.state.product_detail.product_label+' - '+this.state.product_detail.periode_name);
                }
            }
            if(this.state.product_detail.product_description && this.state.product_detail.product_description.length > 0) {
                if (!this.state.default_products_details_origin_id || this.state.default_products_details_origin_id !== this.state.product_detail.id) {
                    this.devisInputProductDescription.val(this.state.product_detail.product_description);
                }
            }
        }

        if(this.state.locations_labels.length > 0) {
            this.divLibLocation.html(this.state.locations_labels);
            tiret = ' - ';
        } else {
            this.divLibLocation.html(this.props.trad.configurer_espace);
        }

        if(this.state.disposition && this.state.disposition.value != '') {
            this.divLibRmType.html(tiret+this.state.disposition.label_without_pax);
            tiret = ' - ';
        } else {
            this.divLibRmType.html('');
        }

        if(parseInt(this.state.pax) > 0) {
            this.divLibRmPax.html(tiret+this.state.pax+' PAX');
            tiret = ' - ';
        } else {
            this.divLibRmPax.html('');
        }

        this.divHourStart.text(this.state.hour_start ?? '');
        this.divHourEnd.text((this.state.hour_end ?? '') != '' ? '/ '+(this.state.hour_end ?? '') : '');

        if(this.props.products_type_slug == 'meeting-room') {
            let link = $('.link-configure-product[data-index="'+this.props.index+'"]');
            let new_class = 'badge-gc-orange';
            if(this.state.hour_start != '' && this.state.locations_ids != '') {
                new_class = 'badge-gc-green';
            }
            link.removeClass('badge-gc-orange').removeClass('badge-gc-green').addClass(new_class);
        }
        
    }

    handleClose = () => {
        GLOBAL_NAV.close($('section[data-tag="providers-requests_hotels-configure_product"]'));
    }

    checkIsLoaded() {
        return this.state.locations_component_loaded && 
            ((this.state.dispositions_component_loaded && this.state.products_component_loaded) || this.props.products_type_slug != 'meeting-room');
    }

    render() {
        const { t: gctrad } = this.props;
        return (
            <div className="vh-100">
                <div className="px-4">
                    <div className="fixed-part sticky">
                        <div className="border-bottom mb-2 d-flex justify-content-between align-items-center">
                            <h2 className="text-gc-dark-blue m-0 pt-4 pb-2">{this.props.label_modal_header} <span className="content">{this.state.product_title}</span></h2>
                            <small data-alert-function-sheets className="badge badge-gc-orange d-none mt-2">{this.props.alert_function_sheets}</small>

                            {this.state.global && this.state.global == 1 && 
                                <small className="badge badge-gc-orange mt-2">{gctrad('Les salles ne peuvent être bloquées pour des produits hors dates')}</small> 
                            }

                            <div><button type="button" className="btn btn-orange text-white font-weight-bold" onClick={this.handleClose}>
                                {this.props.trad.label_close}
                            </button></div>

                        </div>
                        

                        <div className="gc-form p-2 bg-light mb-3">
                            <div className='row m-0'>
                                <div className='col-6 col-xl-3 p-1'>
                                    <input type="time" 
                                        className={"form-control input_hour_start font-weight-bold border-0 " +(this.state.hour_start_displayed == '' ? 'text-gc-orange' : 'text-gc-green')} 
                                        name="hour_start" 
                                        value={this.state.hour_start_displayed} 
                                        onChange={this.handleHourStartChange} 
                                        onBlur={this.handleHourStartBlur} 
                                    />
                                </div>
                                <div className='col-6 col-xl-3 p-1'>
                                    <input type="time" 
                                        className={"form-control input_hour_end font-weight-bold border-0 " +(this.state.hour_end_displayed == '' ? 'text-gc-orange' : 'text-gc-green')} 
                                        name="hour_end" 
                                        value={this.state.hour_end_displayed} 
                                        onChange={this.handleHourEndChange} 
                                        onBlur={this.handleHourEndBlur} 
                                    />
                                </div>

                                <div className="col-12 col-xl-6 p-1">
                                    <LocationsSelector 
                                        hotels_id={this.props.hotels_id} 
                                        onChange={this.handleChangeLocations}
                                        onLoad={this.handleLoadLocations}
                                        multiple={true}
                                        displayPax={true}
                                        label={this.props.label_locations}
                                        name="locations_ids[]"
                                        defaultValue={this.state.default_locations}
                                        >
                                    </LocationsSelector>
                                </div>


                                { this.props.products_type_slug == 'meeting-room' && (
                                    <div className="col-12 col-xl-6 p-1">
                                        <ProductsDetailsSelector 
                                            hotels_id={this.props.hotels_id} 
                                            onChange={this.handleChangeProductDetail}
                                            onLoad={this.handleLoadProducts}
                                            locations={this.state.locations}
                                            defaultValue={this.state.default_products_details_origin_id}
                                            client_lang={this.props.client_lang}
                                            >
                                        </ProductsDetailsSelector>
                                    </div>
                                )}

                                { this.props.products_type_slug == 'meeting-room' && (
                                    <div className="col-6 col-xl-3 p-1">
                                        <DispositionsSelector 
                                            onChange={this.handleChangeDisposition}
                                            onLoad={this.handleLoadDispositions}
                                            allPax={this.state.all_pax}
                                            defaultValue={this.state.default_meeting_rooms_type_slug}
                                            >
                                        </DispositionsSelector>
                                    </div>
                                )}

                                { this.props.products_type_slug == 'meeting-room' && (
                                    <div className="col-6 col-xl-3 p-1">
                                        <div className="input-group min-w-100px">
                                            <input type="text" 
                                                className={"form-control input_pax font-weight-bold text-right border-0 " +(this.state.pax > 0 ? 'text-gc-green' : 'text-gc-orange')} 
                                                name="pax" 
                                                value={this.state.pax} 
                                                onChange={this.handlePaxChange}
                                            />
                                            <div className="input-group-append">
                                                <span className={"font-weight-bold input-group-text border-0 " +(this.state.pax > 0 ? 'text-gc-green' : 'text-gc-orange')}>{this.props.trad.label_pax}</span>
                                            </div>
                                        </div>
                                        
                                    </div>
                                )}

                            </div>
                        </div>

                    </div>

                    {this.props.display_calendar && <div>
                        <ConfigureFormCalendar 
                            index={this.props.index} 
                            hour_start={this.state.hour_start} 
                            hour_end={this.state.hour_end}
                            pax={this.state.pax}
                            meeting_rooms_type_slug={this.state.disposition ? this.state.disposition.value : null}
                            locations_id={this.state.locations_ids}
                            hotels_id={this.props.hotels_id}
                            requests_hotels_id={this.props.requests_hotels_id}
                            type="product"
                            resize_height={true}
                            parentLoaded={this.state.isLoaded}
                            date_start={this.props.date_start} 
                            base_current_url={this.props.base_current_url} 
                        >
                        </ConfigureFormCalendar>
                    </div>}
                </div>
                
            </div>
        )
    }
}

const ConfigureProductForm = withTranslation()(ConfigureProductFormComponent);
export default ConfigureProductForm;
